import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"email-3, envelope"} maskId="square-filled-radius-0-stroke-1-IconEmail3"><path d="M22 7.00004V4H2V7.00004C4.6016 9.4785 8.12312 11 12 11C15.8769 11 19.3984 9.4785 22 7.00004Z" fill="currentColor"/><path d="M22 8.34314C19.3008 10.6246 15.811 12 12 12C8.189 12 4.69924 10.6246 2 8.34314V20H22V8.34314Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEmail3;
